<template>
  <el-dialog
    title="已选择的IPC分类"
    :visible.sync="view_dialogVisible"
    width="60%"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-table :data="tableDataview" style="width: 100%" border>
      <el-table-column label="序号" type="index" width="60" align="center">
        <template
          v-slot="scope"
        >{{ (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="IPC名称" prop="name" show-overflow-tooltip header-align="center" />
      <el-table-column label="IPC" align="center" width="100" prop="ipc" show-overflow-tooltip />
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
    <span slot="footer" class="dialog-footer" style="text-align:center">
      <el-button type="primary" @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>
    <script>
    import { industryIpc } from "@/api/index";
export default {
  props: {
    view_dialogVisible: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: String,
      default : ""
    },
    areaCode:{
      type: String, 
      default: ""
    }
  },
  data() {
    return {
      tableDataview:[],
      ipcList:[],
      queryParams:{
        pageSize: 10,
        pageNum: 1,
        type:'view'
      },
      total:0
    };
  },
  created(){
     this.ipcList = this.$common.strtoarr2(this.tableData)
     this.getList()
  },
  methods: {
    handleClose() {
      this.$emit("update:view_dialogVisible", false);
    },
    getList(){
      industryIpc({ids:this.ipcList,...this.queryParams,areaCode:this.areaCode}).then(res=>{
        this.tableDataview = res.data.list
        this.total = res.data.total
      })
    },
  }
};
</script>
    <style lang="less" scoped>

/deep/ .el-dialog {
    margin-top:2vh!important;
}
</style>